import { gql } from "@apollo/client";

export const GET_ALL_MODO_INFUSION = gql`
query GetAllModoInfusion($campo: String!) {
      comboRI(campo: $campo){
            idComboRI,
            campo,
            activo,
            comboRIValor{
              idComboRIValor,
              valor
            }
      }
}`;